export default __webpack_public_path__ + "static/media/thsarabunnew_italic-webfont.6990572e.ttf";